import { render, staticRenderFns } from "./rosteringplan.vue?vue&type=template&id=419d04c4&scoped=true&"
import script from "./rosteringplan.vue?vue&type=script&lang=js&"
export * from "./rosteringplan.vue?vue&type=script&lang=js&"
import style0 from "./rosteringplan.vue?vue&type=style&index=0&id=419d04c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419d04c4",
  null
  
)

export default component.exports